import Box from '@mui/material/Box';

const MapLayout = (props) => {
  const boxStyles = {
    paddingBottom: {
      xs: 'calc(2vh)',
      sm: 'calc(6vh)',
      md: 'calc(10vh)',
      lg: 'calc(15vh)',
    },
    marginLeft: {
      xs: 'calc(2vw)',
      sm: 'calc(2vw)',
      md: 'calc(4vw)',
      lg: 'calc(6vw)',
    },
    paddingLeft: {
      xs: 'calc(2vw)',
      sm: 'calc(2vw)',
      md: 'calc(4vw)',
      lg: 'calc(6vw)',
    },
    marginRight: {
      xs: 'calc(1vw)',
      sm: 'calc(2vw)',
      md: 'calc(2vw)',
      lg: 'calc(6vw)',
    },
    paddingRight: {
      xs: 'calc(2vw)',
      sm: 'calc(2vw)',
      md: 'calc(2vw)',
      lg: 'calc(6vw)',
    },
  };
  return <Box sx={boxStyles}> {props.children} </Box>;
};

export default MapLayout;
